import React, { Component } from "react";
import swal from "sweetalert2";
import { connectStore } from "redux-box";
import { module as misc } from "store/misc";
import { Heading, InputBox, ThemeButton } from "@/static/styled/custom.styled";

class GlobalMagicOtp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      otpInput: "",
    };
    this.userEdited = false;
  }

  componentDidMount() {
    if (this.props.misc && this.props.misc.requestMagicOtp) {
      this.props.misc.requestMagicOtp();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.misc &&
      nextProps.misc.magicOtp !== this.props.misc.magicOtp &&
      nextProps.misc.magicOtp !== null &&
      nextProps.misc.magicOtp !== undefined
    ) {
      this.userEdited = false;
      this.setState({
        otpInput: String(nextProps.misc.magicOtp),
      });
    }
  }

  handleOtpChange = (e) => {
    this.userEdited = true;
    this.setState({ otpInput: e.target.value });
  };

  handleSave = () => {
    const otp = (this.state.otpInput || "").trim();

    if (!otp) {
      swal.fire({
        title: "Error!",
        text: "Magic OTP cannot be empty",
        timer: 1500,
      });
      return;
    }

    this.userEdited = false;
    this.props.misc.updateMagicOtp({
      otp,
    });
  };

  render() {
    const { magicOtpLoading, magicOtpSaving, magicOtp } = this.props.misc || {};
    const { otpInput } = this.state;
    const hasExistingOtp =
      magicOtp !== null && magicOtp !== undefined && String(magicOtp).trim() !== "";
    const buttonText = magicOtpLoading
      ? "Create/Update Magic OTP"
      : hasExistingOtp
        ? "Update Magic OTP"
        : "Create Magic OTP";

    return (
      <div className="p-4">
        <div className="card" style={{ maxWidth: 720 }}>
          <div className="card-body">
            <Heading style={{ marginBottom: 10 }}>Global Magic OTP</Heading>
            <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
              <div>
                <InputBox
                  type="text"
                  inputMode="numeric"
                  placeholder="Enter Magic OTP"
                  value={otpInput}
                  onChange={this.handleOtpChange}
                />
              </div>

              <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
                <ThemeButton
                  primary
                  onClick={this.handleSave}
                  disabled={magicOtpLoading || magicOtpSaving}
                >
                  {buttonText}
                </ThemeButton>
                {magicOtpSaving ? <span>Saving...</span> : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connectStore({
  misc,
})(GlobalMagicOtp);

